import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";

const NavItem = (props) => {
  const pageURI = window.location.pathname + window.location.search;
  const liClassName = props.path === pageURI ? "nav-item active" : "nav-item";
  return (
    <li className={liClassName}>
      <Link to={props.path} target="_blank" className="nav-link py-0 text-dark">
        {props.name}
        {props.path === pageURI ? (
          <span className="sr-only">(current)</span>
        ) : (
          ""
        )}
      </Link>
    </li>
  );
};

class NavDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: false,
    };
  }
  showDropdown(e) {
    e.preventDefault();
    this.setState((prevState) => ({
      isToggleOn: !prevState.isToggleOn,
    }));
  }
  render() {
    const classDropdownMenu =
      "dropdown-menu" +
      (this.state.isToggleOn ? " show" : "") +
      " dropdown-menu-left";
    return (
      <li className="nav-item dropup active">
        <Link
          to="/"
          className="nav-link dropdown-toggle py-0 text-dark"
          id="navbarDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={(e) => {
            this.showDropdown(e);

          }}
        >
          {this.props.name}
        </Link>
        <div className={classDropdownMenu} aria-labelledby="navbarDropdown">
          {this.props.children}
        </div>
      </li>
    );
  }
}

class NavbarBottom extends React.Component {
  moveForwardClick = () => {
    this.props.moveForwardHandler();
  };
  moveBackwardClick = () => {
    this.props.moveBackwardHandler();
  };

  render() {
    return (
      <nav
        className="navbar fixed-bottom navbar-expand-lg  navigation-nav"
        id="bottomNavbar"
      >
        <div className="container-fluid">
          <ul className="navbar-nav mr-auto text-dark">
            <div className="d-flex flex-row">
              <Button href="#/" target="_blank" variant="outline-dark" className="d-inline mx-1" id="navBottomText"><span >Home</span></Button>

              <Dropdown className="d-inline mx-1">
                <Dropdown.Toggle variant="outline-dark" id="navBottomText">
                  Pages
                </Dropdown.Toggle>

                <Dropdown.Menu id="navBottomText">
                  {this.props.children}
                </Dropdown.Menu>
              </Dropdown>


              <Dropdown className="d-inline mx-1">
                <Dropdown.Toggle variant="outline-dark" id="navBottomText">
                  Courses
                </Dropdown.Toggle>

                <Dropdown.Menu id="navBottomText">
                  <Dropdown.Item href="#/Module1" target="_blank" >I have no idea what I want to do</Dropdown.Item>
                  <Dropdown.Item href="#/Module2" target="_blank">I have some ideas and want to focus my thinking</Dropdown.Item>
                  <Dropdown.Item href="#/Module3" target="_blank">I have changed my mind and need to rethink my plans</Dropdown.Item>
                  <Dropdown.Item href="#/Module4" target="_blank">I know what I want to do but not sure how to get there</Dropdown.Item>
                  <Dropdown.Item href="#/Module5" target="_blank">I am ready to apply for a job or PhD</Dropdown.Item>
                  <Dropdown.Item href="#/Module6" target="_blank">I have a job, further study place or will be starting my own
                    business</Dropdown.Item>
                  <hr />
                  <Dropdown.Item href="#/" target="_blank" id="navBottomText">Homepage</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

            </div>
          </ul>



          <a className="navbar-brand py-0 d-none d-md-block text-dark">
            {this.props.title}
          </a>

          <ul className="nav navbar-nav ml-auto text-dark">
            <div>
              <i
                className="fas fa-angle-left fa-2x"
                onClick={this.moveBackwardClick}
              ></i>

              <i
                className="fas fa-angle-right fa-2x"
                onClick={this.moveForwardClick}
              ></i>
            </div>
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavbarBottom;
